import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SERVICES, CONTACT, waLink, CREDS, MAPS_LINK, FOOTER_LINE } from "@/lib/content";
import { useGoTo } from "./Header";

export const Footer = () => {
  const goTo = useGoTo();
  return (
  <footer data-testid="site-footer" className="grain relative overflow-hidden bg-[#1B2F1D] text-[#F9F8F3]">
    <div className="relative mx-auto max-w-[1400px] px-5 pt-10 sm:px-8 md:pt-20">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-12 md:gap-12">
        <div className="col-span-2 md:col-span-5">
          <Logo light />
          <p className="mt-4 max-w-sm text-[#F9F8F3]/70">Agronomia e engenharia para quem vive do campo. Pelotas — atuação em toda a metade sul do RS.</p>
          <a data-testid="footer-whatsapp" href={waLink()} target="_blank" rel="noreferrer" className="mt-6 inline-flex rounded-full bg-[#5D995E] px-6 py-3 text-sm font-semibold text-[#0F1F10] transition-colors duration-300 hover:bg-[#8FC690]">
            Falar pelo WhatsApp
          </a>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#8FC690]">Navegação</p>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <button data-testid={`footer-nav-${n.id}`} onClick={() => goTo(n.id)} className="link-underline text-[#F9F8F3]/80">{n.label}</button>
              </li>
            ))}
          </ul>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.15em] text-[#8FC690]">Por perfil</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link data-testid="footer-profile-produtores" to="/para-produtores" className="link-underline text-[#F9F8F3]/80">Produtores rurais</Link></li>
            <li><Link data-testid="footer-profile-advogados" to="/para-advogados" className="link-underline text-[#F9F8F3]/80">Advogados e escritórios</Link></li>
            <li><Link data-testid="footer-profile-bancos" to="/para-instituicoes-financeiras" className="link-underline text-[#F9F8F3]/80">Bancos e cooperativas</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#8FC690]">Serviços</p>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-2 md:block md:space-y-2">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <Link to={`/${s.id}`} data-testid={`footer-service-${s.id}`} className="link-underline">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#8FC690]">Contato</p>
          <div className="mt-5 space-y-2 text-[#F9F8F3]/80">
            <p><a data-testid="footer-phone" href={`tel:+${CONTACT.wa}`} className="link-underline">{CONTACT.phone}</a></p>
            <p className="break-all"><a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="link-underline">{CONTACT.email}</a></p>
            <p><a data-testid="footer-address" href={MAPS_LINK} target="_blank" rel="noreferrer" className="link-underline">{CONTACT.address}</a> · {CONTACT.city} · {CONTACT.cep}</p>
            <p data-testid="footer-hours">{CONTACT.hours}</p>
            <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 font-medium text-[#F9F8F3]">
              <Instagram className="h-4 w-4 text-[#8FC690]" /> {CONTACT.instagramHandle}
            </a>
          </div>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.15em] text-[#8FC690]">Institucional</p>
          <ul className="mt-3 space-y-2 text-sm text-[#F9F8F3]/80">
            <li><Link data-testid="footer-pelotas" to="/municipios/pelotas" className="link-underline">Atendimento em Pelotas/RS</Link></li>
            <li><Link data-testid="footer-privacy" to="/politica-de-privacidade" className="link-underline">Política de Privacidade</Link></li>
          </ul>
        </div>
      </div>
      <p aria-hidden="true" className="mt-14 hidden select-none whitespace-nowrap font-serif text-[17vw] font-semibold uppercase leading-[0.8] tracking-tight text-[#F9F8F3]/[0.06] md:block">
        Melo Agro
      </p>
      <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-3">
        {CREDS.map((c) => (
          <div key={c.label} data-testid={`footer-cred-${c.label.toLowerCase().replace(/\s+/g, "-")}`} className="bg-[#1B2F1D] px-4 py-3">
            <p className="font-mono text-xs uppercase tracking-[0.15em] text-[#8FC690]">{c.label}</p>
            <p className="mt-1 text-sm text-[#F9F8F3]/85">{c.value}</p>
          </div>
        ))}
      </div>
      <div className="flex flex-col justify-between gap-3 border-t border-white/10 py-4 text-sm text-[#F9F8F3]/60 sm:flex-row sm:py-6">
        <p data-testid="footer-legal-line">{FOOTER_LINE}</p>
        <p>Pelotas · RS · Brasil</p>
      </div>
      <div className="h-[68px] sm:hidden" />
    </div>
  </footer>
  );
};
